import React from 'react';
import { Card, Grid, Skeleton, Divider } from 'antd';
import { useTheme } from '../../Shared/GlobalContext/ThemeContext';

const { useBreakpoint } = Grid;

const AgentCardSkeletonItem = () => {
    const screens = useBreakpoint();
    const isMobile = screens?.xs;
    const { isDarkMode } = useTheme();

    const themeColors = {
        divider: isDarkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.06)',
    };

    return (
        <Card
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: isMobile ? '100%' : '280px',
            }}
            bordered={false}
            styles={{
                body: {
                    padding: '16px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
            actions={[
                <Skeleton.Button active size="small" shape="circle" key="1" />,
                <Skeleton.Button active size="small" shape="circle" key="2" />,
                <Skeleton.Button active size="small" shape="circle" key="3" />
            ]}
        >
            {/* Header: Agent Name + Status */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '12px'
            }}>
                <Skeleton.Input
                    active
                    style={{
                        width: '140px',
                        height: '22px',
                    }}
                />
                <Skeleton.Button
                    active
                    size="small"
                    style={{
                        width: '60px',
                        height: '22px',
                        borderRadius: '4px'
                    }}
                />
            </div>

            <Divider style={{ margin: '0 0 12px 0', borderColor: themeColors.divider }} />

            {/* Channels Section */}
            <div style={{ marginBottom: '12px' }}>
                <Skeleton.Input
                    active
                    style={{
                        width: '70px',
                        height: '14px',
                        marginBottom: '6px'
                    }}
                />
                <div style={{ display: 'flex', gap: '4px' }}>
                    <Skeleton.Button active size="small" style={{ width: '70px', height: '22px' }} />
                    <Skeleton.Button active size="small" style={{ width: '70px', height: '22px' }} />
                </div>
            </div>

            {/* Knowledge Bases Section */}
            <div style={{ marginBottom: '12px' }}>
                <Skeleton.Input
                    active
                    style={{
                        width: '100px',
                        height: '14px',
                        marginBottom: '6px'
                    }}
                />
                <div style={{ display: 'flex', gap: '4px' }}>
                    <Skeleton.Button active size="small" style={{ width: '60px', height: '22px' }} />
                    <Skeleton.Button active size="small" style={{ width: '60px', height: '22px' }} />
                </div>
            </div>

            {/* Admins Section */}
            <div style={{ flex: 1 }}>
                <Skeleton.Input
                    active
                    style={{
                        width: '50px',
                        height: '14px',
                        marginBottom: '6px'
                    }}
                />
                <div style={{ display: 'flex', gap: '4px' }}>
                    <Skeleton.Button active size="small" style={{ width: '80px', height: '22px' }} />
                </div>
            </div>
        </Card>
    );
};

export default AgentCardSkeletonItem;